"use client";

import React from "react";
import Image from "next/image";
import styles from "./AlternatingSection.module.css";
import Link from "next/link";

export default function AlternatingSection({ dynamicData }) {
  if (!dynamicData || !dynamicData.items || dynamicData.items.length === 0) return null;

  const getImageUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    if (url.startsWith("data:") || url.startsWith("blob:")) return url;
    
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_BASE_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
    
    if (url.includes("/uploads/")) {
      const cleanPath = url.substring(url.indexOf("/uploads/"));
      return `${apiUrl}${cleanPath}`;
    }
    
    if (url.startsWith("uploads/") || url.startsWith("/uploads/")) {
      const cleanPath = url.startsWith("/") ? url : `/${url}`;
      return `${apiUrl}${cleanPath}`;
    }
    
    if (url.startsWith("http")) return url;
    return url;
  };

  return (
    <section className={styles.section}>
      <div className="container">
        {dynamicData.items.map((item, idx) => {
          const isEven = idx % 2 === 0;
          return (
            <div 
              key={idx} 
              className={`${styles.row} ${isEven ? "" : styles.reverse}`}
              data-reveal={isEven ? "slide-right" : "slide-left"}
            >
              {/* Image Side */}
              <div className={styles.imageColumn}>
                <div className={styles.imageWrapper}>
                  <Image 
                    src={getImageUrl(item.image)} 
                    alt={item.title} 
                    className={styles.image}
                    width={600}
                    height={400}
                  />
                  <div className={styles.imageBg}></div>
                </div>
              </div>

              {/* Text Side */}
              <div className={styles.textColumn}>
                {item.tag && <div className={styles.tag}>{item.tag}</div>}
                <h2 className={styles.title}>{item.title}</h2>
                <p className={styles.description}>{item.description}</p>
                
                {item.points && item.points.length > 0 && (
                  <ul className={styles.points}>
                    {item.points.map((p, pIdx) => (
                      <li key={pIdx}>
                        <i className="fa-solid fa-circle-check"></i>
                        <span>{p.text}</span>
                      </li>
                    ))}
                  </ul>
                )}

                {item.buttonText && (
                  <Link href={item.buttonLink || "#"} className={styles.btn}>
                    {item.buttonText} <i className="fa-solid fa-arrow-right-long"></i>
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
